// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"31":"5a386933ea5f4f15","118":"867cb548db4b4c61","626":"4facee9899b069e7"}[chunkId] + ".js";
};